export default __webpack_public_path__ + "static/media/patreonbutton.a5474fd9.webp";